const sublinks = [
  {
    page: "home",
    links: [{ url: "/" }],
  },
  {
    page: "coaches",
    links: [{ url: "/coaches" }],
  },
  {
    page: "players",
    links: [{ url: "/players" }],
  },
  // {
  //   page: "about ",
  //   // subpage: "contact us",
  //   links: [{ url: "/about-us" }],
  // },
  {
    page: "blog",
    links: [{ url: "/blog" }],
  },
  // {
  //   page: "events",
  //   links: [{ url: "/events" }],
  // },
];

export default sublinks;
